<template>
  <!-- <div class="white pa-0" > -->
    <v-row class="text-center px-0 py-2">
    <!-- <v-col class="white mb-5 py-0" cols="12"> -->
      <!-- ряд 1 сектор 1 -->
      <v-col class="white col-md-5 offset-md-1 col-12 offset-0">
        <!-- <div
          class="ma-0 pa-0"
          data-aos="flip-right"
          data-aos-delay="1500"
          data-aos-duration="2000"
          data-aos-easing="ease-out-back"
          data-aos-mirror="true"
          data-aos-once="true"
          data-aos-anchor-placement="bottom-bottom"
        > -->
          <div
          class="ma-0 pa-0"
        >
          <v-img
            :src="require('../assets/ShelterLogo3.png')"
            aspect-ratio="1.5"
            contain
            max-height="350"
            class="my-6"
          >
          </v-img>
        </div>
        <!-- <div style="height: 70px"></div> -->
      </v-col>

      <!-- ряд 1 сектор 2 -->
      <!-- <v-col
        class="white col-md-5 col-12"
        data-aos="fade-left"
        data-aos-offset="100"
        data-aos-delay="200"
        data-aos-duration="2000"
        data-aos-mirror="true"
        data-aos-once="false"
        data-aos-anchor-placement="bottom-bottom"
        data-aos-anchor=".picture-element"
      > -->
      <v-col class="white col-md-5 col-12">
        <div
          class="white d-flex align-center"
          style="max-height: 300px; min-height: 250px"
        >
          <span>
            <!-- <h1 class="display-2 font-weight-bold mb-3" > -->
            <h1
              class="headline font-weight-bold mb-3 mt-13"
              style="letter-spacing: 0.13125em !important;  color: #616161"
            >
              КТО МЫ
            </h1>
            <v-divider
              class="grey darken-2 mx-auto"
              light
              style="min-height: 3px; max-width: 50px"
            ></v-divider>
            <h1
              class="headline font-weight my-7 mx-3 textWordBreak"
              style="letter-spacing: 0.01125em !important"
            >
              Благотворительное общественное объединение помощи безнадзорным
              животным
            </h1>
          </span>
        </div>
        <!-- <div :class="`${colorOne}`" style="height: 70px"></div> -->
      </v-col>
      <!-- <v-divider light></v-divider> -->
    <!-- </v-col> -->
    </v-row>


  <!-- </div> -->
</template>



<script>
export default {
  name: "SectionTwo",
  data() {
    return {

    };
  },


};
</script>

